
export default class Score {
    static init() {
        const scores = document.querySelectorAll('.jsScore');

        if (scores.length > 0) {
            scores.forEach( score => {
               let items = score.querySelectorAll('.jsScoreItem');
               let input = score.querySelector('input');

               if (items.length > 0 && input) {
                   Score.recalculateScore(parseInt(input.value), items);
                   items.forEach( item => {
                       item.addEventListener('click', e => {
                           e.preventDefault();
                           Score.handleUserAction(items, item, input, false);
                       });
                       item.addEventListener('touchend', e => {
                           e.preventDefault();
                           Score.handleUserAction(items, item, input, false);
                       });
                       if (window.matchMedia('(min-width: 1280px)').matches) {
                           item.addEventListener('mouseover', () => {
                               Score.handleUserAction(items, item, input, true);
                           });
                           item.addEventListener("mouseleave", () => {
                               items.forEach( item => {
                                   item.classList.remove('score__item--hover');
                               })
                           });
                       }
                   });
               }
            });
        }
    }

    static handleUserAction(items, item, input, hover) {
        let chosenScore = parseInt(item.dataset.score);
        if (chosenScore) {
            let newInputValue = chosenScore;
            input.value = `${newInputValue}`;
            Score.recalculateScore(newInputValue, items, hover);
        }
    }

    static recalculateScore(inputValue, items, hover) {
        if (!inputValue) {
            inputValue = 0;
        }
        let currentValue = inputValue;

        if (currentValue > 5) {
            currentValue = 5;
        }

        if (currentValue < 0) {
            currentValue = 0;
        }

        let activeClass = 'score__item--active';
        if (hover) {
            activeClass = 'score__item--hover';
        }

        items.forEach( item => {
            item.classList.remove(activeClass);
        });

        for (let i = 0; i < currentValue; i++) {
            items[i].classList.add(activeClass);
        }
    }
}